<div class="root">
  <div class="container">
    <h1 class="title">{{ 'skyproRoutingPage.thereIsNoPage' | transloco | skyUiTypograf }}</h1>
    <p class="description">{{ 'skyproRoutingPage.wrongLink' | transloco | skyUiTypograf }}</p>
    <a href="/student-cabinet">
      <ds-button type="primary-blue" size="m">
        {{ 'skyproRoutingPage.goToMain' | transloco | skyUiTypograf }}
      </ds-button>
    </a>
  </div>
</div>
